import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { useAuth } from "../../lib/auth";

export default function RepInvite() {
  const { token } = useParams();
  const nav = useNavigate();
  const { login } = useAuth();
  const [info, setInfo] = useState(null);
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/rep-invite/${token}`).then((r) => setInfo(r.data)).catch((e) => setInfo({ error: formatApiError(e) })); }, [token]);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Use at least 8 characters");
    if (pw !== pw2) return toast.error("Passwords don't match");
    setBusy(true);
    try {
      const { data } = await api.post(`/rep-invite/${token}/accept`, { password: pw });
      await login(data.email, pw);
      toast.success("Welcome to the team!");
      nav("/rep", { replace: true });
    } catch (er) { toast.error(formatApiError(er)); setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[var(--bg)] flex items-center justify-center p-6" data-testid="rep-invite-page">
      <div className="w-full max-w-md bg-white border border-[var(--line)] rounded-3xl p-8 shadow-xl">
        <p className="text-xs uppercase tracking-[0.22em] text-[var(--gold)]">Locked In Forever · Rep Portal</p>
        {!info ? <Loader2 className="w-6 h-6 animate-spin text-[var(--gold)] mt-6" /> : info.error ? <>
          <h1 className="font-serif text-3xl mt-2">Invite not valid</h1><p className="text-sm text-[#5c544b] mt-2" data-testid="rep-invite-error">{info.error}</p></> : <form onSubmit={submit} className="space-y-4">
          <h1 className="font-serif text-3xl mt-2">Welcome, {(info.name || "").split(" ")[0]}</h1>
          <p className="text-sm text-[#5c544b]">Choose a password for <b data-testid="rep-invite-email">{info.email}</b>.</p>
          <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password (8+ characters)" className="input-luxe" autoComplete="new-password" data-testid="rep-invite-password" />
          <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Repeat password" className="input-luxe" autoComplete="new-password" data-testid="rep-invite-password2" />
          <button disabled={busy} className="btn-gold w-full disabled:opacity-50" data-testid="rep-invite-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />}Set password & open portal</button>
        </form>}
      </div>
    </div>
  );
}
